(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  const popup = document.getElementById('newsletter-drawer');
  if (popup) {
    const hideForever = () =>
      localStorage.getItem('theme:popup-filled') === 'true' ||
      localStorage.getItem('theme:popup-hide') === 'true';
    const hideSession = () => sessionStorage.getItem('theme:popup-closed') === 'true';
    const hidePaid = () => window.LX_PAID_TRAFFIC === true;

    if ((hideForever() || hideSession() || hidePaid()) && !(window.Shopify && window.Shopify.designMode)) {
      popup.remove();
    } else {
      const persistDismiss = () => {
        const box = popup.querySelector('[name="newsletter-hide"]');
        if (box && box.checked) {
          localStorage.setItem('theme:popup-hide', 'true');
          localStorage.setItem('theme:popup-filled', 'true');
        } else {
          sessionStorage.setItem('theme:popup-closed', 'true');
        }
      };

      popup.querySelectorAll('[is="close-button"]').forEach((button) => {
        button.addEventListener('click', persistDismiss);
      });

      popup.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          persistDismiss();
        }
      });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
